import { render, staticRenderFns } from "./BillingDOView.vue?vue&type=template&id=8d4bf04e"
import script from "./BillingDOView.vue?vue&type=script&lang=js"
export * from "./BillingDOView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports